const mediaItems = [
  {
    title: '热播电影精选',
    desc: '院线大片、经典佳片，高清画质即刻畅享',
    tag: '电影',
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20scene%20with%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20golden%20and%20crimson%20tones%2C%20film%20grain%20texture%2C%20epic%20atmosphere%2C%20movie%20poster%20aesthetic&width=600&height=400&seq=media-1&orientation=landscape',
  },
  {
    title: '高分电视剧',
    desc: '口碑热剧、全网追更，全集一次性看过瘾',
    tag: '剧集',
    img: 'https://readdy.ai/api/search-image?query=TV%20drama%20series%20cinematic%20scene%20with%20warm%20indoor%20lighting%2C%20emotional%20character%20moment%2C%20golden%20amber%20tones%2C%20soft%20depth%20of%20field%2C%20narrative%20storytelling%20visual&width=600&height=400&seq=media-2&orientation=landscape',
  },
  {
    title: '纪录片专区',
    desc: '自然人文、历史探秘，足不出户看遍世界',
    tag: '纪录',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20nature%20cinematography%20with%20warm%20sunlight%2C%20vast%20landscape%2C%20golden%20hour%20tones%2C%20cinematic%20wide%20shot%2C%20atmospheric%20mood%2C%20natural%20beauty&width=600&height=400&seq=media-3&orientation=landscape',
  },
  {
    title: '动漫番剧',
    desc: '国漫日漫、经典番剧，二次元世界随心看',
    tag: '动漫',
    img: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%20cinematic%20composition%20with%20warm%20golden%20lighting%2C%20beautiful%20anime%20character%20scene%2C%20soft%20pastel%20and%20crimson%20accents%2C%20dreamy%20atmosphere%2C%20elegant%20visual&width=600&height=400&seq=media-4&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">精选推荐</h2>
          <p className="mt-2 text-sm text-foreground-500">每日精选高清影视内容，发现你的下一部好片</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div key={item.title} className="group cursor-pointer">
              <div className="relative aspect-video rounded-lg overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-base font-bold text-white">{item.title}</h3>
                </div>
              </div>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}